"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactBootstrap = require("react-bootstrap");
var _Button = require("../Button/Button");
var _indexModule = _interopRequireDefault(require("./index.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
var useRecovery = function useRecovery(_ref) {
  var initialTab = _ref.initialTab,
    callback = _ref.callback,
    dismiss = _ref.dismiss;
  var usernameRef1 = (0, _react.useRef)();
  var idRef1 = (0, _react.useRef)();
  var mobileRef1 = (0, _react.useRef)();
  var idRef2 = (0, _react.useRef)();
  var mobileRef2 = (0, _react.useRef)();
  var body = /*#__PURE__*/_react.default.createElement("div", {
    className: _indexModule.default.body
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tabs, {
    defaultActiveKey: initialTab,
    className: _indexModule.default.tabs
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "password",
    title: "\u10DE\u10D0\u10E0\u10DD\u10DA\u10D8\u10E1 \u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    className: _indexModule.default.form,
    style: {
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _indexModule.default.formGroup,
    "data-required": true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10E1\u10D0\u10EE\u10D4\u10DA\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    ref: usernameRef1
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _indexModule.default.formGroup,
    "data-required": true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    ref: idRef1
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _indexModule.default.formGroup,
    "data-required": true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DB\u10DD\u10D1\u10D8\u10DA\u10E3\u10E0\u10D8 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    ref: mobileRef1
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    direction: 'horizontal',
    gap: 4,
    className: _indexModule.default.buttonsContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'success',
    onClick: function onClick() {
      return callback({
        username: usernameRef1.current.value,
        id: idRef1.current.value,
        mobile: mobileRef1.current.value
      });
    }
  }, "\u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'secondary',
    onClick: dismiss
  }, "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0")))), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Tab, {
    eventKey: "username",
    title: "\u10DB\u10DD\u10DB\u10EE\u10DB\u10D0\u10E0\u10D4\u10D1\u10DA\u10D8\u10E1 \u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0"
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form, {
    className: _indexModule.default.form,
    style: {
      marginBottom: '1rem'
    }
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _indexModule.default.formGroup,
    "data-required": true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DE\u10D8\u10E0\u10D0\u10D3\u10D8 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    ref: idRef2
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Group, {
    className: _indexModule.default.formGroup,
    "data-required": true
  }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Label, null, "\u10DB\u10DD\u10D1\u10D8\u10DA\u10E3\u10E0\u10D8 \u10DC\u10DD\u10DB\u10D4\u10E0\u10D8"), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Form.Control, {
    ref: mobileRef2
  })), /*#__PURE__*/_react.default.createElement(_reactBootstrap.Stack, {
    direction: 'horizontal',
    gap: 4,
    className: _indexModule.default.buttonsContainer
  }, /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'success',
    onClick: function onClick() {
      return callback({
        id: idRef2.current.value,
        mobile: mobileRef2.current.value
      });
    }
  }, "\u10D0\u10E6\u10D3\u10D2\u10D4\u10DC\u10D0"), /*#__PURE__*/_react.default.createElement(_Button.Button, {
    variant: 'secondary',
    onClick: dismiss
  }, "\u10D2\u10D0\u10E3\u10E5\u10DB\u10D4\u10D1\u10D0"))))));
  return {
    body: body
  };
};
var _default = useRecovery;
exports.default = _default;